// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Carousel3d from 'vue-carousel-3d';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueScrollTo from 'vue-scrollto';
import 'aos/dist/aos.css';
import VueI18n from 'vue-i18n';
// Translations
import en from '@/translations/en.json';
import de from '@/translations/de.json';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Carousel3d);
Vue.use(VueScrollTo, { duration: 1000 });
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAwBeLd8jvrb9kM7XaOVdWsvwV9HnBI188',
  },
});
Vue.use(VueI18n);

const messages = {
  en,
  de,
};

const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
localStorage.setItem('lang', lang);

const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
  mounted() {
    import('aos').then(AOS => AOS.init({
      duration: 1200,
      offset: 150,
    }));
  },
});



// WEBPACK FOOTER //
// ./src/main.js